import React from 'react';
import styled, {css} from 'styled-components';
import {List} from './ContentStyles';
import {COLORS, ELEVATIONS, SIZES} from '../styleVars';

const ExpansionHeader = styled(List)`
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;
  width: 100%;
  &:hover {
    background-color: ${COLORS.lightestGrey};
  }
`;

interface ExpansionBodyProps {
  height: number;
  bgColor: string;
  init?: boolean;
}

const ExpansionBody = styled.div<ExpansionBodyProps>`
  box-sizing: border-box;
  box-shadow: ${ELEVATIONS.Accordion};
  background-color: ${(props) => (props.bgColor ? props.bgColor : COLORS.lighterGrey)};
  transition: ${(props) => (props.init ? 'height 0s linear' : 'height 0.2s linear')};
  height: ${(props) => props.height}px;
  overflow: hidden;
  user-select: none;
  width: 100%;
`;

interface SvgProps {
  open: boolean;
  addmargin: 'left' | 'right';
  init?: boolean;
}

const StyledSvg = styled.svg<SvgProps>`
  fill: currentColor;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: ${SIZES[24]};
  color: ${COLORS.darkerGrey};
  flex-shrink: 0;
  transition: ${(props) => (props.init ? 'transform 0s linear' : 'transform 0.2s linear')};
  transform: ${(props) => (props.open ? 'rotate(180deg)' : 'none')};
  ${(props) =>
    props.addmargin &&
    css`
  margin-${props.addmargin}: ${SIZES['14']};
  `}
`;

interface ToggleIconProps {
  /**
   * Specifies rotation of icon.
   */
  open: boolean;
  /**
   * Specifies additional margin on the left or right side.
   */
  addmargin: 'left' | 'right';
  /**
   * Specifies init render with open expansion body on page entering
   */
  init?: boolean;
  /**
   * @ignore
   */
  className?: string;
  /**
   * @ignore
   */
  style?: object;
}

const ToggleIcon: React.FC<ToggleIconProps> = ({open, addmargin, init, className, style}) => {
  return (
    <StyledSvg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      className={className}
      addmargin={addmargin}
      style={style}
      open={open}
      init={init}>
      <path d='M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z' />
    </StyledSvg>
  );
};

export {ExpansionHeader, ExpansionBody, ToggleIcon};
